export enum SyncJobStatus {
    Completed = "completed",
    CompletedWithErrors = "completed-with-errors",
    Scheduled = "scheduled",
    InProgress = "in-progress",
    InProgressWithErrors = "in-progress-with-errors",
    Failed = "failed",
}

export const SYNC_JOB_STATUS_DISPLAY: Record<SyncJobStatus, "success" | "inactive" | "warning" | "critical"> = {
    [SyncJobStatus.Completed]: "success",
    [SyncJobStatus.CompletedWithErrors]: "critical",
    [SyncJobStatus.Scheduled]: "inactive",
    [SyncJobStatus.InProgress]: "warning",
    [SyncJobStatus.InProgressWithErrors]: "warning",
    [SyncJobStatus.Failed]: "critical",
};

export const SYNC_JOB_STATUS_LABEL: Record<SyncJobStatus, string> = {
    [SyncJobStatus.Completed]: "completed",
    [SyncJobStatus.CompletedWithErrors]: "completed with errors",
    [SyncJobStatus.Scheduled]: "scheduled",
    [SyncJobStatus.InProgress]: "in progress",
    [SyncJobStatus.InProgressWithErrors]: "in progress with errors",
    [SyncJobStatus.Failed]: "failed",
};

export type SyncJob = {
    id: string;
    start_date: string;
    end_date: string;
    status: SyncJobStatus;
    submitted_at: string;
    jobs_synced: number;
    jobs_total: number;
};
